<script>
export default {
  props: {
    level: {
      type: Number,
      default: 2
    }
  },
  render (h) {
    return h(
      'h' + this.level,
      {
        class: 'page-title'
      },
      this.$slots.default
    )
  }
}
</script>
